import { Component, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { PasswordModule } from 'primeng/password';
import { ControlsOf } from '../../../shared/forms/forms-common';
import { IRegisterCommand } from '../../../shared/model/fss.api';
import { InfoCircle } from '../../../shared/icons/info-circle/info-circle';
import { FieldComponent } from '../../../shared/ui/field/field';
import { FormControlPipe } from '../../../shared/pipes/form-control.pipe';
import { Lock03 } from '../../../shared/icons/lock-03/lock-03';
import { TextInput } from '../../../shared/ui/text-input/text-input';
import { EmailInputComponent } from '../../../shared/components/email-input/email-input';
import { Arrow } from '../../../shared/icons/arrow/arrow';
import { ButtonComponent, ButtonSeverity, ButtonSize } from '../../../shared/ui/button/button';

import { PasswordRequirements } from '../../../shared/components/password-requirements/password-requirements';

@Component({
  standalone: true,
  selector: 'app-register-step-3',
  imports: [
    PasswordRequirements,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    FloatLabelModule,
    IconFieldModule,
    InputIconModule,
    PasswordModule,
    InfoCircle,
    FieldComponent,
    FormControlPipe,
    Lock03,
    TextInput,
    EmailInputComponent,
    Arrow,
    ButtonComponent,
  ],
  templateUrl: './register-step-3.html',
  styleUrl: './register-step-3.scss',
})
export class RegisterStep3 {
  form = input.required<FormGroup<ControlsOf<IRegisterCommand>>>();
  isValid = input.required<boolean>();

  back = output<void>();
  submit = output<void>();
  protected readonly ButtonSeverity = ButtonSeverity;
  protected readonly ButtonSize = ButtonSize;
}
